import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Modal, FooterButton } from 'Core/components';
import CarriersAddEditForm from './carriermasters-add-edit-form';
import { saveCarrier } from './store/slice';
import { AppModal } from '../components/app-modals';

const CarriersAddEdit = ({ showModal, modalData, onCloseModal }) => {
  const carrierData = modalData;
  const [formData, setFormData] = useState(carrierData || null);
  const dispatch = useDispatch();
  const isEditMode = Boolean(carrierData?.id);

  const onChangesForm = data => {
    setFormData(data);
  };

  const handleClose = () => {
    onCloseModal();
  };

  const body = () => {
    return (
      <div className="row">
        <CarriersAddEditForm data={formData} onChanges={onChangesForm} />
      </div>
    );
  };

  const footer = () => {
    const onSave = () => {
      const payload = {
        ...(formData || {}),
        userId: localStorage.getItem('UserId'),
      };
      dispatch(saveCarrier(payload));
    };

    return (
      <div className="row">
        <div className="col-12 col-lg-8"></div>
        <div className="col-12 col-lg-4">
          <FooterButton
            cancelText="Cancel"
            saveText={isEditMode ? 'Save Carrier' : 'Save Carrier'}
            onSave={onSave}
            onCancel={handleClose}
          />
        </div>
      </div>
    );
  };

  return (
    <Modal
      id="carriers-modal"
      show={showModal}
      size="xl"
      title={isEditMode ? 'Edit Carrier' : 'Add Carrier'}
      body={body}
      footer={footer}
      handleClose={handleClose}
    />
  );
};

CarriersAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.object,
  onCloseModal: PropTypes.func,
};

export default AppModal(CarriersAddEdit);

